import { AccordionContent, AccordionProduct } from "@foodpilot/foods";
import { ProductFormProductPackaging } from "src/pages/Product/ProductForm/ProductForm.types";
import { LineTitle } from "./LineTitle";
import { LineContent } from "./LineContent";

type PackagingAccordionProps = {
    packagings: ProductFormProductPackaging[];
    setProductPackagings: (newPackagings: ProductFormProductPackaging[]) => void;
};
export const PackagingAccordion = (props: PackagingAccordionProps) => {
    const { packagings, setProductPackagings } = props;

    const packagingKey = (packaging: ProductFormProductPackaging): string =>
        packaging.packaging?.["@id"] ??
        packaging.packagingReference?.["@id"] ??
        packaging.packagingReference?.compositeId ??
        "";

    const pages: AccordionContent[] = packagings.map((packaging) => {
        return {
            title: (
                <LineTitle
                    packaging={packaging}
                    setPackaging={(newPackaging) => {
                        const newPackagingsList = packagings.map((packaging) => {
                            if (packagingKey(packaging) === packagingKey(newPackaging)) {
                                return newPackaging;
                            }
                            return packaging;
                        });
                        setProductPackagings(newPackagingsList);
                    }}
                />
            ),
            content: <LineContent packaging={packaging} />,
        };
    });
    return <AccordionProduct pages={pages} />;
};
